import React, { useEffect, useState } from "react";
import { createSwapy } from "swapy";
import { useTranslation } from "react-i18next";
import DashboardHeader from "./DashboardHeader";
import DashboardSlot from "./DashboardSlot";
import EditModeSlot from "./EditModeSlot";
import {
  DEFAULT_DASHBOARD_SLOTS,
  DASHBOARD_ORDER_STORAGE_KEY,
  SWAPY_CONFIG,
} from "./constants";

const DashBoard = () => {
  const { t: translate } = useTranslation();
  const [editMode, setEditMode] = useState(false);

  const slotItems = localStorage.getItem(DASHBOARD_ORDER_STORAGE_KEY)
    ? JSON.parse(localStorage.getItem(DASHBOARD_ORDER_STORAGE_KEY))
    : DEFAULT_DASHBOARD_SLOTS;

  useEffect(() => {
    if (editMode) {
      const container = document.querySelector(".dashboardSwap");
      const swapy = createSwapy(container, SWAPY_CONFIG);
      swapy.onSwap(({ data }) => {
        localStorage.setItem(DASHBOARD_ORDER_STORAGE_KEY, JSON.stringify(data.object));
      });

      return () => {
        if (swapy) {
          swapy.destroy();
        }
      };
    }
  }, [editMode]);

  return (
    <>
      <DashboardHeader editMode={editMode} setEditMode={setEditMode} translate={translate} />
      <div
        key={`dashboardContainer${editMode}`}
        className="dashboardSwap w-full p-2 flex flex-col gap-2"
      >
        <DashboardSlot
          slotPosition="1"
          slotId={slotItems["1"]}
          editMode={editMode}
          editModeSlot={(id, name) => <EditModeSlot identifier={id} name={name} />}
        />
        <div className="flex justify-between gap-2 min-h-[35vh]">
          <div className="flex w-full">
            <DashboardSlot
              slotPosition="2"
              slotId={slotItems["2"]}
              editMode={editMode}
              editModeSlot={(id, name) => <EditModeSlot identifier={id} name={name} />}
            />
          </div>
          <div className="flex w-full">
            <DashboardSlot
              slotPosition="3"
              slotId={slotItems["3"]}
              editMode={editMode}
              editModeSlot={(id, name) => <EditModeSlot identifier={id} name={name} />}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default DashBoard;
